import { Layout, Account } from '../components';

const AccountPage = () => {
  return (
    <Layout>
      <Account />
    </Layout>
  );
};

export default AccountPage;
